export class InsufficientTokenAmount extends Error {}
